import reduceReducers from 'reduce-reducers';
import mapActionToReducer from 'redux-action-reducer-mapper';
import initialState from './initialState';
import dataReducers from './dataReducers';

export default reduceReducers(
  mapActionToReducer({
    default: initialState,
    ...dataReducers,
  }),
);
